export default "__VITE_PUBLIC_ASSET__c54b8585__"